
import { Component, HostListener, OnInit, ViewChild, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { AlertService } from '../../services/alert/alert.service';
import { FAICListDetails } from './faic-list';
import { ReportsService } from '../../services/reports/reports.service';
import { Observable } from 'rxjs';
import { LoadingService } from '../../services/loading/loading.service';
import * as FileSaver from 'file-saver';
import { DownloadFileResponse } from '../../shared/common-components/file-storage/downloadFileResponse';

@Component({
    selector: 'app-faic-list',
    templateUrl: './faic-list.component.html',
    styleUrls: ['./faic-list.component.css'],
    standalone: false
})


export class FaicListComponent implements OnInit {

    public errorMessage = '';
    // to be used later (maybe) for column selection and sorting
    order = 'faic';
    reverse = false;

    private strloader;
    paginationPageSize;
    domLayout;
    faicListDetails = [
        {}
    ];
    faicListColumnDefs = [
        { headerName: 'FAIC Code', field: 'faicdisplay', filter: 'agTextColumnFilter', sortable: true, width: 150,
        cellClass: 'textFormat'},
        { headerName: 'Agency Name', field: 'agencyname', filter: 'agTextColumnFilter', sortable: true},
        { headerName: 'Bureau Name', field: 'bureauname', filter: 'agTextColumnFilter', sortable: true},
        { headerName: 'Auth Official Name', field: 'rptOfficial', filter: 'agTextColumnFilter', sortable: true},
        { headerName: 'Location Id', field: 'orgId', filter: 'agTextColumnFilter', sortable: true, type: 'leftaligned', width: 150},
        { headerName: 'User First Name', field: 'firstname', filter: 'agTextColumnFilter', sortable: true},
        { headerName: 'User Last Name', field: 'lastname', filter: 'agTextColumnFilter', sortable: true},
       // { headerName: 'Address', field: 'address1', filter: true, sortable:true },
       // { headerName: 'Address 2', field: 'address2', filter: true, sortable:true },
        { headerName: 'City', field: 'city', filter: 'agTextColumnFilter', sortable: true, width: 150},
        { headerName: 'State', field: 'state', filter: 'agTextColumnFilter', sortable: true, width: 100},
        { headerName: 'Zip', field: 'zip', filter: 'agTextColumnFilter', sortable: true, width: 100}

    ];
    excelStyles = [
        {
           id: 'textFormat',
           dataType: 'string',
         }
       ];
    constructor(private reportsService: ReportsService,
        private alertService: AlertService,
        private loadingService: LoadingService,
        private cdref: ChangeDetectorRef
    ) {
        this.paginationPageSize = 25;
    }

    ngOnInit() {
        // kickoff the actual search query
        this.onSearch();
    }

    onSearch() {
        this.faicListDetails = [];
        this.errorMessage = '';
        this.loadingService.show();
        // call to server for data.  Results will be stored in faicListDetails.
        this.reportsService.getFAICDetails(this.order, this.reverse)
            .subscribe(data => {
                this.faicListDetails = data;
            },
                (error) => {
                    this.errorMessage = error;
                    console.log('No records found for the search criteria: ' + error);
                    this.alertService.error('No records found for the search criteria ');
                    // this.setupPagination();
                    this.loadingService.hide();
                }, () => {
                    console.log('Successfully retrieved faic list details: ', this.faicListDetails);
                    // this.loadingService.hide();
                    // this.setupPagination();
                    this.loadingService.hide();
                }
            );
    }

    generateDownload() {
        let reportResult: DownloadFileResponse;

        this.loadingService.show();

        this.reportsService.getFAICXlsx().subscribe(result => {
            reportResult = result as DownloadFileResponse;
            const byteData: number[] = reportResult.byteData;
            const fileName: string = reportResult.fileName;
            const numRows: number = reportResult.numberOfExcelRows;
            const bytes = new Uint8Array(byteData);
            const blob = new Blob([bytes], {
                type: null
            });

            if (numRows > 0) {
                // SAVE EXCEL FILE
                FileSaver.saveAs(blob, fileName);
                this.alertService.success('FAIC List Report created - ' + numRows + ' Records found');
            } else {
                this.alertService.success('No records found for selected options');
            }
            this.loadingService.hide();
        }, (error) => {
            this.alertService.error(error);
            console.log('Error.......... ', error);
            this.loadingService.hide();
        }, () => {

        }
        );

    }

    // might be needed later for sorting
    setOrder(value: string) {
        this.reverse = !this.reverse;
        this.order = value;
        this.onSearch();
    }

    // not sure if this might be needed in the future
    isNotEmpty(data: any): boolean {

        if (typeof data !== 'undefined' && data) {
            return true;
        } else { return false; }
    }
}
